(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mp-language-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mp-language-menu')) {
    customElements.define('mp-language-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.mp-language-selector__panel');
        if (!this.details || !this.summary || !this.panel) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details.addEventListener('toggle', () => {
          this.summary.setAttribute('aria-expanded', String(this.details.open));
          if (!this.details.open) this.cancelClose();
        }, options);
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        this.summary.addEventListener('click', (event) => {
          if (!this.details.open) return;
          event.preventDefault();
          if (this.closingAnimation) {
            this.cancelClose();
            this.summary.setAttribute('aria-expanded', 'true');
          } else {
            this.close();
          }
        }, options);
        document.addEventListener('pointerdown', (event) => {
          if (this.details.open && !this.contains(event.target)) this.close();
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            this.close();
            this.summary.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        }, options);
      }
      close() {
        if (!this.details.open || this.closingAnimation) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !this.panel.animate) {
          this.details.open = false;
          return;
        }
        this.panel.inert = true;
        this.summary.setAttribute('aria-expanded', 'false');
        const animation = this.panel.animate([
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-3px)' }
        ], { duration: 140, easing: 'ease-out', fill: 'forwards' });
        this.closingAnimation = animation;
        animation.onfinish = () => {
          this.details.open = false;
          this.cancelClose();
        };
      }
      cancelClose() {
        if (this.closingAnimation) this.closingAnimation.cancel();
        this.closingAnimation = null;
        if (this.panel) this.panel.inert = false;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cancelClose();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
